import { Axios } from 'axios';

declare global {
    interface Window {
        axios: Axios;
    }
}

export interface ForethoughtConfig {
    token: string;
    apiKey: string;
}

export const getForethoughtConfig = () => window.axios.get('/chat/support/config').then((res) => res.data);
